import { render } from "./ImageViewerToolbar.vue?vue&type=template&id=0b5e2b42&scoped=true&ts=true"
import script from "./ImageViewerToolbar.vue?vue&type=script&lang=ts"
export * from "./ImageViewerToolbar.vue?vue&type=script&lang=ts"

import "./ImageViewerToolbar.vue?vue&type=style&index=0&id=0b5e2b42&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5e2b42"]])

export default __exports__